import React from "react";
import { cn } from "@/lib/utils";
import { DraftStatusBadgeProps, DraftStatus } from "./types";
import { Badge } from "@/components/ui/badge";
import {
  FileText,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
} from "lucide-react";

const statusConfig: Record<
  DraftStatus,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
    icon: React.ReactNode;
  }
> = {
  draft: {
    label: "Draft",
    variant: "outline",
    className:
      "border-orange-500 text-orange-600 bg-orange-50 dark:bg-orange-950",
    icon: <FileText className="w-3 h-3" />,
  },
  pending_review: {
    label: "Pending Review",
    variant: "secondary",
    className: "border-blue-500 text-blue-600 bg-blue-50 dark:bg-blue-950",
    icon: <Clock className="w-3 h-3" />,
  },
  approved: {
    label: "Approved",
    variant: "default",
    className: "border-green-500 text-green-600 bg-green-50 dark:bg-green-950",
    icon: <CheckCircle className="w-3 h-3" />,
  },
  rejected: {
    label: "Rejected",
    variant: "destructive",
    className: "border-red-500 text-red-600 bg-red-50 dark:bg-red-950",
    icon: <XCircle className="w-3 h-3" />,
  },
};

export const DraftStatusBadge: React.FC<DraftStatusBadgeProps> = ({
  status,
  className,
}) => {
  const config = statusConfig[status] || {
    label: status,
    variant: "outline" as const,
    className: "text-muted-foreground",
    icon: <AlertCircle className="w-3 h-3" />,
  };

  return (
    <Badge
      variant={config.variant}
      className={cn(
        "text-xs flex items-center space-x-1 px-2 py-1",
        config.className,
        className,
      )}
    >
      {config.icon}
      <span>{config.label}</span>
    </Badge>
  );
};

export default DraftStatusBadge;
